import React from 'react'
import { useNavigate } from 'react-router-dom'
import Header2 from '../Layouts/Header2'
import Footer from '../Layouts/Footer'
import Image from '../Assets/Images/OurOffering.png'
import { FaArrowLeft } from "react-icons/fa";

const OurOffering = () => {
    const navigate = useNavigate();

    return (
        <>
        

            <div className="max-w-6xl mx-auto mt-[70px] flex items-center gap-4">
                <span 
                    className="cursor-pointer text-[#70962f] text-xl hover:text-[#5a7a26]"
                    onClick={() => navigate(-1)}
                    title="Go back"
                >
                    <FaArrowLeft />
                </span>
                <h2 className="text-4xl font-bold text-[#70962f]">Our Offering</h2>
            </div>

            <p className="text-md text-gray-600 max-w-6xl mx-auto my-4">
                SolarMore Solution is dedicated to delivering sustainable and cost-effective renewable energy
                solutions through our extensive network of private, grid-connected solar and wind farms
                across India. Our diverse portfolio includes solar, wind, and wind-solar hybrid power procurement solutions, designed to help corporates achieve 100% renewable energy sourcing while
                benefiting from substantial savings.
            </p>

            <img src={Image} className="w-[1000px] h-full object-cover mx-auto" alt="Our Offering" />

            <Footer />
        </>
    )
}

export default OurOffering
